import ReactGA from 'react-ga4';

let gaInitialized = false;

export const initializeGoogleAnalytics = () => {
  const measurementId = window.ENV.REACT_APP_GA_MEASUREMENT_ID;

  if (!measurementId) {
    return;
  }

  ReactGA.initialize(measurementId);
  gaInitialized = true;
};

export const initializeGoogleAnalyticsIfCookieBannerAccepted = () => {
  if (gaInitialized) {
    return;
  }
  const cookieBannerIsAccepted = localStorage.getItem('cookieBannerIsAccepted') === 'true';
  if (cookieBannerIsAccepted) {
    initializeGoogleAnalytics();
  }
};

export const trackPageView = (path: string) => {
  if (gaInitialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};
